/* eslint-disable no-unused-vars */
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
// must manually import the stylesheets for each plugin
import "@fullcalendar/daygrid/main.css";
import interactionPlugin from "@fullcalendar/interaction"; // needed for dayClick
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  timesheetActivitiesBGColor,
  getNewId,
  prepareForCalendar,
  getWorkerName,
  isApproveEnabled,
  approvePunches,
  getStatus,
  dayWiseTimesheetApproval,
} from "./utils";
import {
  canInteractWithTimesheetWeek,
  getEarliestSelectableTimesheetWeekStart,
} from "./historicalTimesheetAuth";

import timeGridPlugin from "@fullcalendar/timegrid";
import "@fullcalendar/timegrid/main.css";
import { Box, Typography } from "@material-ui/core";
import LoaderViewNew from "./LoaderViewNew";
import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import "./TimeSheet.css";
import moment from "moment";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import AddDialog from "./AddDialog";
import DayHeaderContent from "./DayHeaderContent";
import EventContent from "./EventContent";
import Controls from "./Controls";
import Footer from "./Footer";
import { Switch } from "@material-ui/core";
import { FormControlLabel } from "@material-ui/core";
import { fade } from "@material-ui/core/styles";
import { getWorkerPunchRecords, getWeekNumber } from "services";
import { dateConfig } from "config";
import { Link, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { fetchTotalHoursOfWorker } from "services/timesheet";
import SplitDialog from "./SplitDialog";
import { selectedWeekOnReview } from "redux/actions/appActions";
import { properCase } from "utils";
// eslint-disable-next-line no-undef
const isSandbox = process.env.REACT_APP_ENV !== "prod";

const businessHours = {
  // days of week. an array of zero-based day of week integers (0=Sunday)
  daysOfWeek: [0, 1, 2, 3, 4, 5, 6], // Sunday - Saturday

  startTime: "9:00", // a start time (9am in this example)
  endTime: "18:00", // an end time (6pm in this example)
};
const now = moment().format("HH:00:00");

const TimeSheetView = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const locationProps = location.state;
  const [calendarEvents] = useState([]);
  const [addOpen, setAddOpen] = useState(false);
  const [approve, setApprove] = useState(false);
  const [incompletePunchCount, setIncompletePunchCount] = useState(0);
  const [activity, setActivity] = useState(null);
  const [mounted, setMounted] = useState(false);
  const [showBH, setShowBh] = useState(false);
  const [type, setType] = useState("add");
  const [nonew, setNonew] = useState(true);
  const [deleted, setDeleted] = useState(false);
  const [splitOpen, setSplitOpen] = useState(false);
  // const [selectedDate, setSelectedDate] = useState(moment().startOf("week"));

  //const [calEvents, setCalEvents] = useState([]);
  const [selectedFieldDropdowns, setSelectedFieldDropdowns] = useState([]);
  const [loading, setLoading] = useState(true);
  const { appConfig } = useSelector((state) => state);
  const [selectedWorker, setSelectWorker] = useState();
  const [selectedDate, setSelectedDate] = useState(
    appConfig.selectedWeekOnReview
      ? moment(appConfig.selectedWeekOnReview.week).startOf("week")
      : moment().startOf("week")
  );

  const [calendarEventOccur, setCalendarEventOccur] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [punchRecords, setPunchRecords] = useState([]);
  const [timesheetStatus, setTimesheetStatus] = useState("");
  const [activityToSplit, setActivityToSplit] = useState(null);
  const [dayWiseStatus, setDayWiseStatus] = useState({});
  const [activityGroupTotals, setActivityGroupTotals] = useState({});
  const [flagForEventDropOrDrag, setFlagForEventDropOrDrag] = useState(false);
  const [inProgressPunchFlag, setinProgressPunchFlag] = useState(false);
  const calendarComponentRef = useRef();
  const activityRef = useRef();

  const { user } = useSelector((state) => state.user.auth);
  const loggedInUser = useSelector((state) => state.user);
  const loggedInSupervisor = loggedInUser.auth.user.workerId;
  const imtRoleName = loggedInUser?.imtRole?.userRole?.role;
  const canInteractWeek = canInteractWithTimesheetWeek(selectedDate, imtRoleName);
  const { t } = useTranslation();
  const [isChipClickable, setisChipClickable] = useState(true);
  function handleSnackClick(receivedvalue) {
    console.log("received inprogress", receivedvalue);
    setOpen(true);
    if (!receivedvalue) setTimesheetStatus("approved");
    else {
      setTimesheetStatus("");
    }
    // console.log("result 1", timesheetStatus);
  }
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };
  const handleSelectionChange = (selections) => {
    console.log("selections", selections);
    setSelectWorker(selections.selectedWorker);
    setSelectedFieldDropdowns(selections);
    dispatch(selectedWeekOnReview({ week: selections.weekStart }));
    getWorkerPunchRecords(
      selections.selectedWorker.workerId,
      moment(new Date(selectedDate))
        .subtract(1, "days")
        .format(dateConfig.format6),
      moment(new Date(selectedDate)).add(7, "days").format(dateConfig.format6)
    )
      .then((data) => {
        // console.log("this is data ", data);
        let processedData = prepareForCalendar(data);
        setPunchRecords(processedData);
        console.log("this is processedData ", processedData);
        let [approveFlag, incompleteCount] = isApproveEnabled(
          processedData,
          selectedDate
        );

        // console.log("approveFlag", approveFlag);
        setApprove(approveFlag);
        setIncompletePunchCount(incompleteCount);
        setisChipClickable(true);
      })
      .catch((err) => {
        console.error("Err in getWorkerPunches Response: ", err);
      });

    // Todo : Add backend call to timesheet for fetching the daywise status
    //console.log("This is handleSelectionChange selectedDate ", moment(selectedDate).format("dddd"));
    // set dummy data
    const dummyData = {
      Sunday: "Approved",
      Monday: "Approved",
      Tuesday: "Approved",
      Wednesday: "Approved",
      Thursday: "Approved",
      Friday: "Approved",
      Saturday: "Approved",
    };
    setDayWiseStatus(dummyData);
  };

  const handleApproval = async () => {
    const toApprove = ["new", "edit", "auto completed", "auto adjusted"];
    setApprove(false);

    await approvePunches(
      punchRecords,
      selectedWorker,
      selectedDate,
      loggedInSupervisor
    ).then((received) => {
      console.log("received status", received[0]);
      setPunchRecords((p) => {
        let op = [...p];
        for (let i = 0; i < op.length; ++i) {
          let status = op[i].extendedProps.status;
          let outLocalTS = op[i].extendedProps.outLocalTS;

          if (
            moment(op[i].extendedProps.outLocalTS).isAfter(
              moment(selectedDate).add(7, "day")
            )
          ) {
            // console.log("found exclude for ", op[i]);
            continue;
          }
          if (toApprove.includes(status)) {
            if (status == "new") {
              if (outLocalTS) {
                op[i].extendedProps.status = "approved";
                op[i].extendedProps.actionBy = selectedWorker.managerId;
                op[i].extendedProps.actionTS = new Date().toISOString();
              }
            } else {
              op[i].extendedProps.status = "approved";
              op[i].extendedProps.actionBy = selectedWorker.managerId;
              op[i].extendedProps.actionTS = new Date().toISOString();
            }
          }
        }
        return op;
      });
      handleSnackClick(received[0]);
      setNonew(true);
      setDeleted(false);
    });
  };

  const handleDailyApproval = (day, punchesForDay) => {
    let selections = {};
    setisChipClickable(false);
    selections.selectedWorker = selectedWorker;
    selections.weekEnd = selectedFieldDropdowns.weekEnd;
    selections.weekStart = selectedFieldDropdowns.weekStart;
    const weekNumber = getWeekNumber(selectedFieldDropdowns.weekStart);
    punchesForDay = punchesForDay.filter(
      (punch) => punch.extendedProps.status !== "approved"
    );
    console.log("you are here with data", day, punchesForDay);
    //make the backend call for daily approval here.
    dayWiseTimesheetApproval(
      weekNumber,
      selectedWorker.workerId,
      day,
      punchesForDay,
      loggedInSupervisor
    ).then(() => {
      handleSelectionChange(selections);
    });
  };

  useEffect(() => {
    if (user && user.workerId) {
      let userWorkerId = user.workerId;
    }
  }, []);

  useEffect(() => {
    console.log("location props inside punch", locationProps);
    if (
      locationProps &&
      locationProps.punch &&
      appConfig.selectedWeekOnReview?.week
    )
      openEventWithoutClick(locationProps.punch, "edit");
  }, [locationProps]);

  function openEventWithoutClick(punch, type) {
    console.log(" datai inside open");
    activityRef.current = punch;
    console.log("punchData",punch);
    setActivity({
      start: new Date(punch.inLocalTS),
      end: punch.outLocalTS === "" ? new Date() : punch.outLocalTS,
      title: properCase(t("other.tlEdit")),
      updateFlag: true,
      id: punch.id,
      buildingId: punch.buildingId,
      districtId: punch.districtId,
      jobfamily: punch.jobfamily,
      project: punch.project,
      freeFormText: punch.freeFormText,
      group: { value: punch.activityGroup, label: punch.activityGroup },
      jobName: punch.jobName,
      jobProjectInfo: punch.jobProjectInfo,
      status: punch.status,
      exceptionName: punch.exceptionName,
      customerSite: punch.customerSite,
      weekNumber: punch.weekNumber,
      projectDetails: punch.projectDetails ? punch.projectDetails : "",
      inTrip: punch.inTrip,
      outTS:punch.outTS,
      activityName:punch.activityName
    });
    if (punch?.outTS == ""){
      setFlagForEventDropOrDrag(true)
    }
    setAddOpen(true);
  }

  useEffect(() => {
    if (mounted) {
      const footer = document.querySelector(".fc-footer-toolbar");
      const api = calendarComponentRef.current.getApi();
      if (footer)
        ReactDOM.render(
          <Footer currentWeekDate={api.getDate()} events={api.getEvents()} />,
          footer
        );
      getWorkerPunchRecords(
        selectedWorker.workerId,
        moment(new Date(selectedDate))
          .subtract(1, "days")
          .format(dateConfig.format6),
        moment(new Date(selectedDate)).add(7, "days").format(dateConfig.format6)
      )
        .then((data) => {
          // console.log("This is data useeffect ", data);
          let processedData = prepareForCalendar(data);
          //  console.log("this is processedData use effect", processedData);
          let [approveFlag, incompleteCount] = isApproveEnabled(
            processedData,
            selectedDate
          );
          console.log("record", data);
          //console.log("approveFlag", approveFlag);
          setApprove(approveFlag);
          setIncompletePunchCount(incompleteCount);
        })
        .catch((err) => {
          console.error("Err in getWorkerPunches Response: ", err);
        });
      // Todo : add here the same logic for fetching daywise status
      // const dummyData = {
      //   Sunday: "Approved",
      //   Monday: "Approved",
      //   Tuesday: "Approved",
      //   Wednesday: "Approved",
      //   Thursday: "Approved",
      //   Friday: "Approved",
      //   Saturday: "Approved",
      // }
      // setDayWiseStatus(dummyData);
    }
  }, [
    mounted,
    calendarEventOccur,
    calendarComponentRef.current &&
      calendarComponentRef.current.getApi().getEvents(),
  ]);

  useEffect(() => {
    fetchTotalHoursOfWorker(selectedWorker?.workerId, selectedDate).then(
      (result) => {
        console.log("result from timesheet", result);
        setTimesheetStatus(result?.timesheetStatus);
        setActivityGroupTotals(result?.weekTotalHours?.activityGroupTotals);
      }
    );
    setNonew(true);
  }, [selectedWorker, selectedDate]);

  const handleSelect = (info) => {
    if (!canInteractWithTimesheetWeek(info.startStr || selectedDate, imtRoleName)) {
      return;
    }
    setType("add");
    // console.log("Selected", info.startStr, info.endStr);
    setActivity({
      start: info.startStr,
      end: info.endStr,
      title: properCase(t("pgReview.btnAddPunch")),
    });
    setAddOpen(true);
  };

  const handleBHChange = (e, v) => {
    setShowBh(v);
  };

  const handleWeekChange = (date) => {
    const api = calendarComponentRef.current.getApi();
    //console.log("this is handleweekchange ", moment(api.currentDataManager.data.viewTitle));
    //console.log("this is handleweekChange ", api.getDate());
    // console.log("this is handleweekChange ", api.getEvents());
    setSelectedDate(date);
    api.gotoDate(date);
  };

  const removeAllEvents = () => {
    calendarComponentRef.current.getApi().removeAllEvents();
  };

  const setEventDetails = (eventInfo, type = "add") => {
    activityRef.current = eventInfo;
    // console.log("this is seteventsdetails ", eventInfo.event);
    if (eventInfo.event?.extendedProps?.outTS == "") {
      setFlagForEventDropOrDrag(true);
      setinProgressPunchFlag(true);
    }
    console.log("eventInfo",eventInfo);
    setActivity({
      start: eventInfo.event.startStr,
      end: eventInfo.event.endStr,
      title: properCase(t("other.tlEdit")),
      updateFlag: true,
      id: eventInfo.event.id,
      buildingId: eventInfo.event.extendedProps.buildingId,
      districtId: eventInfo.event.extendedProps.districtId,
      jobfamily: eventInfo.event.extendedProps.jobfamily,
      project: eventInfo.event.extendedProps.project,
      freeFormText: eventInfo.event.extendedProps.freeFormText,
      group: eventInfo.event.extendedProps.group,
      jobName: eventInfo.event.extendedProps.jobName,
      jobProjectInfo: eventInfo.event.extendedProps.jobProjectInfo,
      status: eventInfo.event.extendedProps.status,
      exceptionName: eventInfo.event.extendedProps.exceptionName,
      customerSite: eventInfo.event.extendedProps.customerSite,
      weekNumber: eventInfo.event.extendedProps.weekNumber,
      projectDetails: eventInfo.event.extendedProps.projectDetails
        ? eventInfo.event.extendedProps.projectDetails
        : "",
        inTrip:eventInfo.event.extendedProps.inTrip,
        outTS:eventInfo.event.extendedProps.outTS,
        activityName:eventInfo.event.extendedProps.activityName
    });
    setAddOpen(true);
  };

  const renderCal = () => {
    setCalendarEventOccur(!calendarEventOccur);
  };

  const workerName = getWorkerName(selectedWorker);

  const dataForSplitAndSplitOpen = (activity) => {
    setActivityToSplit(activity);
    setAddOpen(false);
    setSplitOpen(true);
  };

  const splitActivitySaveHandler = (Id, activities) => {
    let previousRecords = punchRecords.filter((records) => records.id != Id);
    // console.log("this is punch records y", punchRecords);
    console.log("this is punch records y ", activities);
    let tempActivities = activities.map((activity) => {
      let newAct = { ...activity };
      newAct.id = activity.extendedProps.punchId;
      return newAct;
    });
    // console.log("this is punch records y ", tempActivities);
    setPunchRecords((punchRecords) => {
      //  console.log("punchRecords:", punchRecords);
      return [...previousRecords, ...tempActivities];
    });
    setAddOpen(false);
    setSplitOpen(false);
    setTimesheetStatus("");
  };

  return (
    <>
      <LoaderViewNew loading={loading}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Box
            mt={2}
            display="flex"
            flexDirection="column"
            style={{
              width: "100%",
              backgroundColor: "#fff",
              overflow: "auto",
              // height:'100%'
              height: `calc(100vh - (113px - ${isSandbox ? 0 : 65}px) - 32px)`,
            }}
          >
            <Controls
              onWeekChange={handleWeekChange}
              value={selectedDate}
              setLoading={setLoading}
              onChangeSelections={handleSelectionChange}
              selectedDate={selectedDate}
              removeEvents={removeAllEvents}
              locationProps={locationProps}
              approveFlag={approve}
              clickedApproval={handleApproval}
              nonew={nonew}
              workerName={workerName}
              timesheetStatus={timesheetStatus}
              activityGroupTotals={activityGroupTotals}
              deleted={deleted}
              incompletePunchCount={incompletePunchCount}
            />

            <Box
              display="flex"
              flexDirection="row"
              paddingLeft={2}
              paddingRight={2}
              paddingBottom={2}
            >
              {/* {workerName && (
                <Typography
                  variant="subtitle1"
                  className={classes.selectedWorker}
                >
                  {workerName}
                </Typography>
              )} */}
              <Box style={{ flexGrow: 1 }} />
              {/* <FormControlLabel
                value="top"
                control={
                  <Switch
                    color="primary"
                    checked={showBH}
                    onChange={handleBHChange}
                  />
                }
                label="Working Hours"
                labelPlacement="left"
              /> */}
            </Box>

            <FullCalendar
              scrollTime={now}
              stickyHeaderDates
              stickyFooterScrollbar
              // ref={calendarComponentRef}
              dragScroll={true}
              slotDuration={"00:30:00"}
              snapDuration={"00:01:00"}
              events={punchRecords}
              editable={canInteractWeek}
              selectable={canInteractWeek}
              nowIndicator
              eventConstraint={{
                // start: moment(selectedDate).startOf("week").toDate(),
                // end: moment(selectedDate).endOf("week").toDate(),
                start: getEarliestSelectableTimesheetWeekStart(imtRoleName),
                end: moment(new Date()).add(2, "weeks").endOf("week").toDate(),
              }}
              viewDidMount={(args) => {
                args.view.calendar.gotoDate(
                  moment(appConfig.selectedWeekOnReview?.week)
                    .startOf("week")
                    .toDate()
                );
                setMounted(true);
              }}
              expandRows={true}
              footerToolbar={true}
              headerToolbar={false}
              eventResize={(args) => {
                //renderCal();
                setFlagForEventDropOrDrag(true);
                if (canInteractWeek) {
                  setType("edit");
                  setEventDetails(args);
                } else {
                  args.revert();
                }
              }}
              eventDrop={(args) => {
                //renderCal();
                setFlagForEventDropOrDrag(true);
                if (canInteractWeek) {
                  setType("edit");
                  setEventDetails(args);
                } else {
                  args.revert();
                }
              }}
              selectOverlap={false}
              // weekends={false}
              eventResizableFromStart
              height={"100%"}
              businessHours={showBH ? businessHours : false}
              select={handleSelect}
              initialView="timeGridWeek"
              defaultView="timeGridWeek"
              unselectAuto={false}
              eventContent={(eventInfo) => {
                // console.log("eventInfo:", eventInfo.event);
                return <EventContent eventInfo={eventInfo} />;
              }}
              dayHeaderContent={(args) => {
                return (
                  <DayHeaderContent
                    args={args}
                    events={args.view.calendar.getEvents()}
                    dayWiseStatus={dayWiseStatus}
                    setLoading={setLoading}
                    handleDailyApproval={handleDailyApproval}
                    isChipClickable={isChipClickable}
                    setisChipClickable={setisChipClickable}
                  />
                );
              }}
              slotLabelFormat={{
                hour: "numeric",
                // minute: "2-digit",
                meridiem: false,
                hour12: false,
              }}
              eventTimeFormat={{
                hour: "2-digit",
                minute: "2-digit",

                hour12: false,
              }}
              columnHeaderFormat={{ weekday: "long" }}
              header={{
                left: "prev,next today",
                center: "title",
                right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
              }}
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              // ref={calendarComponentRef}
              initialEvents={calendarEvents}
              allDaySlot={false}
              selectMirror={true}
              // eventDrop={(info) => {}}
              eventClick={(eventInfo) => {
                console.log(
                  "Clicked Event Info",
                  eventInfo.event.toPlainObject()
                );
                if (canInteractWeek) {
                  setType("edit");
                  setEventDetails(eventInfo);
                }
              }}
              ref={calendarComponentRef}
            />

            {/* <Box padding={2} style={{ border: "1px solid lightgray" }}>
              <Typography>
                This is width wide footer and it can contain a large text or any
                custom UI
              </Typography>
            </Box> */}
          </Box>
          <AddDialog
            //setSplitOpen={setSplitOpen}
            setActivityGroupTotals={setActivityGroupTotals}
            flagForEventDropOrDrag={flagForEventDropOrDrag}
            dataForSplitAndSplitOpen={dataForSplitAndSplitOpen}
            inProgressPunchFlag={inProgressPunchFlag}
            setNonew={setNonew}
            setDeleted={setDeleted}
            activity={activity}
            type={type}
            worker={selectedWorker}
            addOpen={addOpen}
            setAddopen={setAddOpen}
            loading={loading}
            setLoading={setLoading}
            dropdowns={selectedFieldDropdowns}
            disabled={false}
            selectedWeek={selectedDate}
            onCancel={(shouldUnselect) => {
              console.log("cancel called:", shouldUnselect);
              if (shouldUnselect) {
                calendarComponentRef.current.getApi().unselect();
              }
              setAddOpen(false);
              setFlagForEventDropOrDrag(false);
              setinProgressPunchFlag(false);
              if (activityRef.current?.revert) {
                console.log("revert called:", shouldUnselect);
                activityRef.current.revert();
              }
              //renderCal();
              //setPunchRecords([...punchRecords]);
            }}
            onDelete={(activityId) => {
              if (activityId) {
                // calendarComponentRef.current
                //   .getApi()
                //   .getEventById(activityId)
                //   .remove();
                setPunchRecords((punchRecords) => {
                  return punchRecords.filter(
                    (records) => records.id != activityId
                  );
                });
              }
              // console.log(
              //   "this is calender events ",
              //   calendarComponentRef.current.getApi().getEvents()
              // );
              setAddOpen(false);
              setFlagForEventDropOrDrag(false);
              setinProgressPunchFlag(false);
            }}
            onAddClose={({
              start,
              end,
              group,
              districtId,
              buildingId,
              jobfamily,
              project,
              freeFormText,
              id,
              exceptionName,
              jobProjectInfo,
              customerSite,
              weekNumber,
              projectDetails,
            }) => {
              // console.log(start, end, districtId, buildingId);
              //const id = getNewId();
              // calendarComponentRef.current.getApi().addEvent({
              //   id: id,
              //   title: `${group.label}`,
              //   start: moment(start).toDate(),
              //   end: moment(end).toDate(),
              //   editable: true,
              //   overlap: false,
              //   extendedProps: {
              //     group: group,
              //     districtId: districtId,
              //     buildingId: buildingId,
              //     jobfamily: jobfamily,
              //     project: project,
              //     freeFormText: freeFormText,
              //   },

              //   backgroundColor: fade(timesheetActivitiesBGColor(group), 1),
              //   borderColor: "#fff",
              //   textColor: "#FFF",
              // });
              setPunchRecords((punchRecords) => {
                return [
                  ...punchRecords,
                  {
                    id: id,
                    title: `${group.label}`,
                    start: moment(start).toDate(),
                    end: moment(end).toDate(),
                    editable: true,
                    overlap: false,
                    extendedProps: {
                      group: group,
                      districtId: districtId,
                      buildingId: buildingId,
                      jobfamily: jobfamily,
                      project: project,
                      freeFormText: freeFormText,
                      exceptionName: exceptionName,
                      jobProjectInfo: jobProjectInfo,
                      customerSite: customerSite,
                      inLocalTS: moment(start).toDate(),
                      outLocalTS: moment(end).toDate(),
                      status: "new",
                      weekNumber: weekNumber,
                      projectDetails: projectDetails,
                    },

                    backgroundColor: fade(timesheetActivitiesBGColor(group), 1),
                    borderColor: "#fff",
                    textColor: "#FFF",
                  },
                ];
              });

              calendarComponentRef.current.getApi().unselect();
              setAddOpen(false);
              setFlagForEventDropOrDrag(false);
              setinProgressPunchFlag(false);
              renderCal();
              console.log("Exited");
            }}
            onUpdateClose={({
              start,
              end,
              group,
              districtId,
              buildingId,
              Id,
              jobfamily,
              project,
              freeFormText,
              exceptionName,
              jobProjectInfo,
              customerSite,
              weekNumber,
              projectDetails,
            }) => {
              console.log(
                "update close",
                start,
                end,
                districtId,
                buildingId,
                Id
              );
              // let tempPunchRecords = punchRecords.filter(
              //   (records) => records.id != Id
              // );
              // tempPunchRecords.push({
              //   id: Id,
              //   title: `${group.label}`,
              //   start: moment(start).toDate(),
              //   end: moment(end).toDate(),
              //   editable: true,
              //   overlap: false,
              //   extendedProps: {
              //     group: group,
              //     districtId: districtId,
              //     buildingId: buildingId,
              //     jobfamily: jobfamily,
              //     project: project,
              //     freeFormText: freeFormText,
              //     exceptionName: exceptionName,
              //     jobProjectInfo: jobProjectInfo,
              //   },

              //   backgroundColor: fade(timesheetActivitiesBGColor(group), 1),
              //   borderColor: "#fff",
              //   textColor: "#FFF",
              // }
              // )
              // setPunchRecords([...tempPunchRecords]);
              // let tempActivity = { ...activityRef.current.event }
              // tempActivity.extendedProps
              // calendarComponentRef.current.getApi().getEventById(Id).setExtendedProp( districtId, districtId )

              // activityRef.current.event.setExtendedProp(
              //   "districtId",
              //   districtId
              // );
              // activityRef.current.event.setExtendedProp(
              //   "buildingId",
              //   buildingId
              // );
              // activityRef.current.event.setExtendedProp("id", Id);
              // activityRef.current.event.setExtendedProp("jobfamily", jobfamily);
              // activityRef.current.event.setExtendedProp("project", project);
              // activityRef.current.event.setExtendedProp(
              //   "freeFormText",
              //   freeFormText
              // );
              // activityRef.current.event.setExtendedProp("group", group);
              // activityRef.current.event.setExtendedProp(
              //   "customerSite",
              //   customerSite
              // );
              // activityRef.current.event.setExtendedProp(
              //   "exceptionName",
              //   exceptionName
              // );
              // activityRef.current.event.setExtendedProp(
              //   "jobProjectInfo",
              //   jobProjectInfo
              // );
              // activityRef.current.event.setProp(
              //   "backgroundColor",
              //   fade(timesheetActivitiesBGColor(group), 1)
              // );
              // activityRef.current.event.setExtendedProp(
              //   "outLocalTS",
              //   end
              // );
              // activityRef.current.event.setExtendedProp(
              //   "inLocalTS",
              //   start
              // );
              // activityRef.current.event.setProp("title", `${group.label}`);
              // activityRef.current.event.setEnd(end);
              // activityRef.current.event.setStart(start);

              let previousRecords = punchRecords.filter(
                (records) => records.id !== Id
              );

              setPunchRecords((punchRecords) => {
                // console.log("punchRecords:", punchRecords);
                return [
                  ...previousRecords,
                  {
                    id: Id,
                    title: `${group.label}`,
                    start: moment(start).toDate(),
                    end: moment(end).toDate(),
                    editable: true,
                    overlap: false,
                    extendedProps: {
                      group: group,
                      districtId: districtId,
                      buildingId: buildingId,
                      jobfamily: jobfamily,
                      project: project,
                      freeFormText: freeFormText,
                      exceptionName: exceptionName,
                      jobProjectInfo: jobProjectInfo,
                      customerSite: customerSite,
                      inLocalTS: moment(start).toDate(),
                      outLocalTS: moment(end).toDate(),
                      status: "edit",
                      weekNumber: weekNumber,
                      projectDetails: projectDetails,
                    },

                    backgroundColor: fade(timesheetActivitiesBGColor(group), 1),
                    borderColor: "#fff",
                    textColor: "#FFF",
                  },
                ];
              });

              setAddOpen(false);
              console.log("EDITED");
              renderCal();
              setFlagForEventDropOrDrag(false);
              setinProgressPunchFlag(false);
            }}
          />
          <SplitDialog
            splitOpen={splitOpen}
            setAddOpen={setAddOpen}
            setSplitOpen={setSplitOpen}
            selectedWeek={selectedDate}
            disabled={false}
            loading={loading}
            setLoading={setLoading}
            dropdowns={selectedFieldDropdowns}
            activityToSplit={activityToSplit}
            splitActivitySaveHandler={splitActivitySaveHandler}
            setActivityGroupTotals={setActivityGroupTotals}
          />
          <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleSnackClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert onClose={handleSnackClose} severity="success">
              {properCase(t("other.tltimesheetisapproved"))}
            </Alert>
          </Snackbar>
        </MuiPickersUtilsProvider>
      </LoaderViewNew>
    </>
  );
};

export default TimeSheetView;
